import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { reqGet, reqPost } from "../../Service";

// ------ Styled components ------
const AccountContainer = styled.div`
  padding: 20px;
  background: white;
  border-radius: 8px;
  height: 500px;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const AccountHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #eee;

  span {
    font-size: 14px;
    font-weight: 600;
  }
`;

const AccountList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
`;

const AccountItem = styled.div`
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background 0.2s;
  background: ${({ isSelected }) => (isSelected ? "#dbeafe" : "white")};
  border-left: ${({ isSelected }) =>
    (isSelected ? "4px solid #2563eb" : "4px solid transparent")};

  &:hover {
    background: #f8f9fa;
  }
`;



const TextLabel = styled.span`
  font-size: 14px;
  display: inline-block;
  width: 80px;
`;



/** 편집/삭제 버튼들 */
const ActionButtons = styled.div`
  display: flex;
  gap: 4px;
  margin-top: 4px;

  button {
    padding: 6px 8px;
    border: none;
    background: #f0f0f0;
    cursor: pointer;
    border-radius: 4px;
    font-size: 13px;

    &:hover {
      background: #e8e8e8;
    }

    &.delete {
      color: #dc2626;
      &:hover {
        background: #fee2e2;
      }
    }

    &.edit {
      color: #0066ff;
      &:hover {
        background: #e6f0ff;
      }
    }
  }
`;

// ② 각 줄(row)은 가로 배치
const Row = styled.div`
  display: flex;
  align-items: center;     // 수직 가운데 정렬
  gap: 4px;                // 요소 사이 간격

  /* 여기서 input, button 스타일을 추가 정의 */
  input {
    flex: 1;               // 남는 공간 차지
    height: 36px;
    padding: 0 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
  }

  button {
    width: 48px;           // 혹은 필요한 너비로 조정
    background: #0066ff;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;

    &:hover {
      background: #0052cc;
    }
  }
`;


const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto; 
  grid-template-rows: auto auto;
  gap: 8px;
  align-items: center;
`;

/* 첫째 줄: 새 계정명 (row=1, col=1) */
const AccountInput = styled.input`
  grid-column: 1;
  grid-row: 1;
  width: 85%;
  height: 36px;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 0 12px;
  font-size: 14px;
`;

/* 둘째 줄: 비밀번호 (row=2, col=1) */
const PasswordInput = styled.input`
  grid-column: 1;
  grid-row: 2;
  width: 85%;
  height: 36px;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 0 12px;
  font-size: 14px;
`;

// (3) "추가" 버튼: 1행~2행 모두에서 오른쪽에 표시 (row=1 / span=2)
const AddButton = styled.button`
  grid-column: 2;            /* 두 번째 열 */
  grid-row: 1;               /* 첫 번째 행 */
  height: 36px;
  border: none;
  border-radius: 4px;
  background: #0066ff;
  color: white;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background: #0052cc;
  }
`;
const CancelButton = styled.button`
  grid-column: 2; 
  grid-row: 2;
  height: 36px;
  border: none;
  border-radius: 4px;
  background: #f0f0f0;
  color: #333;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background: #e0e0e0;
  }
`;

// 하단 버튼
const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-top: 8px;
`;

const ActionButton = styled.button`
  flex: 1;
  height: 36px;
  background: ${({ primary }) => (primary ? "#0066ff" : "#f5f5f5")};
  color: ${({ primary }) => (primary ? "white" : "#333")};
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background: ${({ primary }) => (primary ? "#0052cc" : "#e0e0e0")};
  }
`;



// 기존 FieldsRow 스타일 대신, 정보를 감쌀 래퍼 추가
export const FieldsWrapper = styled.div`
  padding: 12px 16px;
  margin-bottom: 8px;
  background-color: #fafafa; 
  border-radius: 4px;
  border: 1px solid #f0f0f0;
`;
// label과 값 사이의 여백
export const FieldLabel = styled.span`
  font-weight: 500;     // 살짝 진하게
  margin-right: 6px;
`;
// 항목 행(줄)마다 간격 부여
export const FieldsRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 6px;   // 각 줄 간격
  font-size: 14px;

  // 마지막 행만 margin-bottom 제거
  &:last-child {
    margin-bottom: 0;
  }
`;

const LabelRow = styled(FieldsRow)`
  margin-bottom: 4px;
`;

// ------ Component ------
export default function AddAccount({ infra_id, onClose, handleApplyCredential }) {
  const [accountList, setAccountList] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [newAccountPassword, setNewAccountPassword] = useState("");
  // 현재 어느 account(계정)을 수정 중인지: accountId
  const [editMode, setEditMode] = useState(null);
  // "새 계정추가" 폼 표시여부
  const [showAddForm, setShowAddForm] = useState(false);

  // 수정 중인 계정 정보 (임시 저장)
  const [editData, setEditData] = useState({
    infra_acc_label: "",
    infra_acc_user: "",
    infra_acc_pass: "",
  });

  // 새 계정 추가를 위한 입력 필드
  const [newAccountName, setNewAccountName] = useState("");

  useEffect(() => {
    getAccountList();
    // eslint-disable-next-line
  }, [infra_id]);

  const getAccountList = () => {
    // 서버에서 계정 목록 가져오기
    reqGet(`/api/getInfraAccountList?hostId=${infra_id}`, {}, (data) => {
      setAccountList(data);
    });
  };

  // 목록에서 클릭하면 선택
  const handleSelect = (account) => {
    // editMode 중이라면 선택 안 바꾸는 게 낫다거나,
    // 혹은 강제로 바꿀 수도 있음. 여기서는 그냥 바꾸도록 처리
    setSelectedAccount(account);
  };

  // '적용' 버튼 클릭 시(모달 닫기 전), 상위(RemoteCard)로 계정 정보 전달
  const handleApply = () => {
    if (handleApplyCredential && selectedAccount) {
      handleApplyCredential(selectedAccount); // 부모 컴포넌트에 최종 선택된 계정 전달
    }
    // 모달을 닫는다면 onClose 호출
    onClose?.();
  };

  // '수정' 버튼 클릭 시
  const handleEdit = (account) => {
    setEditMode(account.accounts_id);
    // 수정 전 기존 데이터 복사
    setEditData({
      infra_acc_label: account.infra_acc_label || "",
      infra_acc_user: account.infra_acc_user || "",
      infra_acc_pass: account.infra_acc_pass || "",
    });
  };

  // 수정 중인 계정 정보 입력값 변경 시
  const handleChange = (field, value) => {
    setEditData((prev) => ({ ...prev, [field]: value }));
  };

  // '저장' 버튼 클릭 시
  const saveEdit = (accountId) => {
    // DB로 수정 요청
    reqPost(
      `/api/accountModify`,
      {
        accountId,
        hostId: infra_id,
        accountName: editData.infra_acc_label,
        accountUser: editData.infra_acc_user,
        accountPass: editData.infra_acc_pass,
      },
      () => {
        setEditMode(null);
        getAccountList();
      }
    );
  };

  // '취소' 버튼 클릭 시
  const cancelEdit = () => {
    setEditMode(null);
    // editData도 초기화
    setEditData({
      infra_acc_label: "",
      infra_acc_user: "",
      infra_acc_pass: "",
    });
  };

  // '삭제' 버튼 클릭 시
  const handleDelete = (accountId) => {
    if (!window.confirm(`${accountId} 계정을 삭제하시겠습니까?`)) return;
    reqPost(`/api/accountDelete`, { accountId }, () => {
      getAccountList();
    });
  };

  // 새 계정 추가
  const addAccountForInfra = () => {
    if (!newAccountName.trim()) return;
    reqPost(
      "/api/accountAdd",
      {
        hostId: infra_id,
        accountName: newAccountName,
        accountpass : newAccountPassword,
      },
      () => {
        setNewAccountName("");
        setNewAccountPassword("");
        getAccountList();
      }
    );
  };

  return (
    <AccountContainer>
      <AccountHeader>
        <span>자격증명 목록</span>
        <span style={{ color: "#666" }}>({accountList.length} 개)</span>
      </AccountHeader>

      <AccountList>
        {accountList.map((account) => {
          const isEditing = editMode === account.accounts_id;
          const isSelected = selectedAccount?.accounts_id === account.accounts_id;

          return (
            <AccountItem
              key={account.accounts_id}
              onClick={() => handleSelect(account)}
              isSelected={isSelected && !isEditing}
            >
              {isEditing ? (
                <>
                  <LabelRow>
                    <TextLabel>계정명</TextLabel>
                    <AccountInput
                      type="text"
                      value={editData.infra_acc_label}
                      onChange={(e) =>
                        handleChange("infra_acc_label", e.target.value)
                      }
                    />
                  </LabelRow>
                  <LabelRow>
                    <TextLabel>비밀번호</TextLabel>
                    <AccountInput
                      type="password"
                      value={editData.infra_acc_pass}
                      onChange={(e) =>
                        handleChange("infra_acc_pass", e.target.value)
                      }
                    />
                  </LabelRow>
                  <ActionButtons>
                    <button className="edit" onClick={() => saveEdit(account.accounts_id)}>
                      저장
                    </button>
                    <button className="edit" onClick={cancelEdit}>
                      취소
                    </button>
                  </ActionButtons>
                </>
              ) : (
                <>
                  {/* 편의상 간단히 표시 */}
                 {/* 정보 표시 부분 */}
<FieldsWrapper>
  <FieldsRow>
    <FieldLabel>ID :</FieldLabel>
    <span><strong>{account.infra_acc_label}</strong></span>
  </FieldsRow>
  <FieldsRow>
    <FieldLabel>PW :</FieldLabel>
    <span>******</span>
  </FieldsRow>
</FieldsWrapper>

{/* 수정·삭제 버튼 부분 */}
<ActionButtons>
  <button className="edit" onClick={() => handleEdit(account)}>
    수정
  </button>
  <button
    className="delete"
    onClick={(e) => {
      e.stopPropagation();
      handleDelete(account.accounts_id);
    }}
  >
    삭제
  </button>
</ActionButtons>
                </>
              )}
            </AccountItem>
          );
        })}
      </AccountList>
           {/* ----- "새 계정추가" 버튼 or 폼 ----- */}
           <hr width="100%"/>
           {!showAddForm ? (
        /* 폼이 안 보일 때: "새 계정추가" 버튼만 */
        <button
          onClick={() => setShowAddForm(true)}
          style={{
            width: "100%",
            height: "36px",
            background: "#0066ff",
            color: "white",
            borderRadius: "4px",
            border: "none",
            fontSize: "14px",
            cursor: "pointer",
          }}
        >
          새 계정추가
        </button>
      ) : (
        /* 폼이 보일 때: GridContainer 사용 */
        
        <GridContainer>
            
        <AccountInput
          placeholder="새 계정명"
          value={newAccountName}
          onChange={(e) => setNewAccountName(e.target.value)}
        />
        <PasswordInput
          type="password"
          placeholder="비밀번호"
          value={newAccountPassword}
          onChange={(e) => setNewAccountPassword(e.target.value)}
        />

        {/* 추가 버튼 */}
        <AddButton onClick={addAccountForInfra}>추가</AddButton>

        {/* 취소 버튼 */}
        <CancelButton onClick={() => setShowAddForm(false)}>취소</CancelButton>
      </GridContainer>
      )}
      <hr width="100%"/>
      <ButtonContainer>
        <ActionButton primary onClick={handleApply} disabled={!selectedAccount}>
          적용
        </ActionButton>
        <ActionButton onClick={onClose}>닫기</ActionButton>
      </ButtonContainer>
    </AccountContainer>
  );
}